/*
 * @Author: zhaoliang
 * @Date: 2023-04-25 11:05:24
 * @LastEditTime: 2023-04-28 16:24:11
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/SignUpMFA/tipsConfig.js
 *
 */

export const step1TipsConfig = [
  {
    title: 'signup-step1-helptext-title-1',
    description: 'signup-step1-helptext-desc-1',
  },
  {
    title: 'signup-step1-helptext-title-2',
    description: 'signup-step1-helptext-desc-2',
  },
  {
    title: 'signup-step1-helptext-title-3',
    description: 'signup-step1-helptext-desc-3',
    linktext: 'signup-step1-helptext-t&c',
    enurl: '/terms',
    frurl: '/terms',
  },
  {
    title: 'signup-step1-helptext-title-4',
    description: 'signup-step1-helptext-desc-4',
    linktext: 'signup-step1-helptext-t&c',
    enurl: '/terms',
    frurl: '/terms',
  },
];

export const step2TipsConfig = [
  {
    title: 'signup-step2-helptext-title-1',
    description: 'signup-step2-helptext-desc-1',
  },
];

export const step3TipsConfig = [
  {
    title: 'signup-step3-helptext-title-1',
    description: 'signup-step3-helptext-desc-1',
  },
  {
    title: 'signup-step3-helptext-title-2',
    description: 'signup-step3-helptext-desc-2',
  },
  {
    title: 'signup-step3-helptext-title-3',
    description: 'signup-step3-helptext-desc-3',
  },
];

export const step4TipsConfig = [
  {
    title: 'signup-step4-helptext-title-1',
    description: 'signup-step4-helptext-desc-1',
  },
];
